module.exports = __webpack_public_path__ + "img/symbol.c63be73e.svg";